<template>
	<div class="container-wrapper">
<go-back v-if="!$store.state.isMobile" v-model="form" url="/admin/notification-schedule-list" label="Back" :backToList="true"></go-back>
<b-container class="laneclosure-add-container" v-if="form != null && loaded">
<b-form @submit="onSubmit" @reset="onReset" v-if="canEditNotificationSchedule()">
	<h1>New Notification</h1>
	<b-row>
		<b-col>
			<b-form-group label="Enabled"
				:state="form.notificationTypeId.status"
				:invalid-feedback="form.notificationTypeId.invalidMessage"
			>
				<div class="yes-no-switch-field">
						<input id="editNotificationEnabled"  class="yes-no-switch" :checked="form.isActive.value" type="checkbox" @change="toggleEnabled()" >
						<label for="editNotificationEnabled"></label>
				</div>
			</b-form-group>
		</b-col>
	</b-row>
	<b-row>
		<b-col>
			<b-form-group label="Type of Notification"
				:state="form.notificationTypeId.status"
				:invalid-feedback="form.notificationTypeId.invalidMessage"
			>
			<b-form-select v-model="form.notificationTypeId.value" @input="form.notificationTypeId.resetStatus()" :state="form.notificationTypeId.status" :options="NotificationSchedule.getNotificationScheduleTypeIdOptions" value-field="id" text-field="name" inline></b-form-select>
			</b-form-group>
		</b-col>
	</b-row>


	<b-row>
		<b-col lg="6">
			<b-form-group label="Send Notification"
				:state="form.fromMinute.status"
				:invalid-feedback="form.fromMinute.invalidMessage"
			>
			<b-input-group>
				<b-form-input id="input-from-minute" placeholder="Minute" v-model="timeLength" @change="setNotificationTime"/>
				<b-form-select v-model="timeUnit" :options="timeOptions" value-field="id" text-field="name" inline @change="setNotificationTime"></b-form-select>
				<b-form-select v-model="timeframe" :options="timeframeOptions" value-field="id" text-field="name" inline @change="setNotificationTime"></b-form-select>
				<b-input-group-addon is-text style="margin-left: -1px">{{NotificationSchedule.getDateSourceText(form.notificationTypeId.value)}}</b-input-group-addon>
			</b-input-group>
			</b-form-group>

		</b-col>
	</b-row>

	<b-row>
		<b-col lg="4">
			<b-form-group
				:state="form.fromMinute.status"
				:invalid-feedback="form.fromMinute.invalidMessage"
			>
			<b-input-group>
				<b-input-group-addon is-text style="margin-left: -1px">Buffer</b-input-group-addon>
				<b-form-input id="input-retry-minute" placeholder="Minute" v-model="retryMinutes" @change="setNotificationTime"/>
				<b-input-group-addon is-text style="margin-left: -1px">Minutes</b-input-group-addon>
			</b-input-group>
			</b-form-group>

		</b-col>
	</b-row>

	<b-row>
		<b-col>
		<div class="">Message will be sent {{NotificationSchedule.getMinutesText(form.notificationTypeId.value, form.fromMinute.value, form.toMinute.value)}}</div>
	</b-col>
	</b-row>
	<b-row>
		<b-col>
			<b-form-group label="Application Notification Text"
				:state="form.appText.status"
				:invalid-feedback="form.appText.invalidMessage"
			>
			<div class="notification-schedule__placeholder">Placeholders: <span>{0}</span> LCR, <span>{1}</span> Request From Date, <span>{2}</span> Request From Time, <span>{3}</span> Request To Date, <span>{4}</span> Request To Time</div>

			<b-form-input placeholder="" v-model="form.appText.value"
				:state="form.appText.status"
				@input="form.appText.resetStatus()"
			></b-form-input>
			</b-form-group>
		</b-col>
	</b-row>

	<b-row>
		<b-col>
			<b-form-group label="Website Notification Text"
				:state="form.webText.status"
				:invalid-feedback="form.webText.invalidMessage"
			>
			<div class="notification-schedule__placeholder">Placeholders: <span>{0}</span> LCR, <span>{1}</span> Request From Date, <span>{2}</span> Request From Time, <span>{3}</span> Request To Date, <span>{4}</span> Request To Time</div>

			<b-form-input placeholder="" v-model="form.webText.value"
				:state="form.webText.status"
				@input="form.webText.resetStatus()"
			></b-form-input>
			</b-form-group>
		</b-col>
	</b-row>



	<b-row>
		<b-col>
			<b-form-group label="Email Subject"
				:state="form.emailSubject.status"
				:invalid-feedback="form.emailSubject.invalidMessage"
			>
			<div class="notification-schedule__placeholder">Placeholders: <span>{0}</span> LCR, <span>{1}</span> Request From Date, <span>{2}</span> Request From Time, <span>{3}</span> Request To Date, <span>{4}</span> Request To Time</div>

			<b-form-input placeholder="" v-model="form.emailSubject.value"
				:state="form.emailSubject.status"
				@input="form.emailSubject.resetStatus()"
			></b-form-input>
			</b-form-group>
		</b-col>
	</b-row>


	<b-row>
		<b-col>
			<b-form-group label="Email Intro"
				:state="form.emailIntro.status"
				:invalid-feedback="form.emailIntro.invalidMessage"
			>
			<wysiwyg v-model="form.emailIntro.value" ref="emailIntro" ></wysiwyg>
			</b-form-group>
		</b-col>
	</b-row>

	<b-row>
		<b-col>
			<b-form-group label="Email Closing"
				:state="form.emailClosing.status"
				:invalid-feedback="form.emailClosing.invalidMessage"
			>
			<wysiwyg v-model="form.emailClosing.value" ref="emailClosing"></wysiwyg>
			</b-form-group>
		</b-col>
	</b-row>

	<b-row>
		<b-col>
			<b-form-group label="Email Template File"
				:state="form.emailTemplateFile.status"
				:invalid-feedback="form.emailTemplateFile.invalidMessage"
			>
			<b-form-input placeholder="" v-model="form.emailTemplateFile.value"
				:state="form.emailTemplateFile.status"
				@input="form.emailTemplateFile.resetStatus()"
			></b-form-input>
			</b-form-group>
		</b-col>
	</b-row>



	<b-row>
		<b-col>
			<b-form-group label="Send To User"
				:state="form.lcrUser.status"
				:invalid-feedback="form.lcrUser.invalidMessage"
			>
			<b-form-select v-model="form.lcrUser.value" @input="setLcrRquired(); form.lcrUser.resetStatus()" :state="form.lcrUser.status" :options="NotificationSchedule.getLcrUserTypeOptions" value-field="id" text-field="name" inline></b-form-select>

			</b-form-group>

			<b-form-group v-if="form.lcrUser.value == 'user_in_org'" label="Select Organization"
				:state="form.organizationId.status"
				:invalid-feedback="form.organizationId.invalidMessage"
			>
			<vue-select-grouped v-model="form.organizationId.value" :canDelete="false" :options="organizations" label="name" :reduce="name => name.id" @input="setOrganization" :disabled="false">
				<template v-slot:option="optionGroup" :option="(typeof option === 'object')?option:{[name]: option, namePath:option.namePath, name:option.name, groupName:option.groupName}">
				</template>
				<template v-slot:option="option">
					<span :class="getLevelClassName(option.level)">{{ option.name }}</span>
				</template>
				<template v-slot:selected-option-container="option" :option="(typeof option === 'object')?option:{[name]: option, namePath:option.namePath, name:option.name}">
					<div class="vs__selected-options" v-html="getFlatTree(option.option)"></div>
				</template>
			</vue-select-grouped>
			</b-form-group>
		</b-col>
	</b-row>


<b-row>
	<b-col>
		<b-button variant="primary" type="button" @click="onSubmit">Save</b-button>
		<b-button variant="secondary" type="button" @click="onCancel" class="ml-3">Cancel</b-button>
	</b-col>
</b-row>

<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
	<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
	<ul>
		<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
	</ul>
	<template slot="footer">
		<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
	</template>
</b-modal>

<!-- leaving page -->
<b-modal centered id="unsaved-changes-error-modal" title="Unsaved Changes" size="lg" v-model="showUnsavedChangesModal" @ok="modalOnCancel()">
	<p class="is-size-6">{{ $t('messages.unsavedChanges') }}</p>
	<template v-slot:modal-footer="{ ok }">
		<!-- <b-button variant="primary"  type="button" @click="modalOnSave">{{$t('labels.save')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button> -->
		<b-button variant="danger" type="button" @click="modalOnLeave">{{$t('labels.leaveAnyway')}}</b-button>
		<b-button variant="secondary"  type="button" @click="modalOnCancel">{{$t('labels.stay')}}</b-button>
	</template>
</b-modal>

</b-form>
</b-container>
</div>
</template>


<script>
import NotificationSchedule from '../../../models/NotificationSchedule';
import ErrorHandler from '../../../utility/ErrorHandler';
import GoBack from '../../../components/GoBack.vue';

import Format from '../../../utility/Format';
import Vue from 'vue'
import { VueSelectGrouped } from '../../../components/vue-select-grouped';

export default {
  name: 'AddNotificationSchedule',

  components: {
		GoBack,
		VueSelectGrouped,
  },

  data() {
	return {
		Format,
		form: null,
		loaded:false,
		showUnsavedChangesModal:false,
		lineIndexError:null,
		NotificationSchedule,
		isButtonDisabled: false,
		saveState:null,
		modalRequiredFieldList: [],
		organizations:[],
		retryMinutes: 0,
		showRequiredFieldModal: false,
		show: true,
		timeUnit: "minutes",
		timeLength: 0,
		timeframe: "after",
		timeOptions: new Array(
			{ id:"minutes", name:"Minute(s)"}
			,{ id:"hours", name:"Hour(s)"}
			,{ id:"days", name:"Day(s)"}
			,{ id:"weeks", name:"Week(s)"}
		),
		timeframeOptions: new Array(
			{ id:"before", name:"Before"}
			,{ id:"after", name:"After"}
		),
		onSubmitPromiseDeferred: {
			resolve:null,
			reject:null
		},
	}
	},
	mounted() {
		if (!this.$store.getters.userHasRole('system_admin')) {
			this.$router.push("/no-access");
		} else {
			this.LoadData(this.$route.params.id);
			this.$nextTick(() => {
			})
		}
   },
	computed: {
		fromLabel() {
			let txt = "From";
			return txt;
		},
		toLabel() {
			let txt = "To";
			return txt;
		},
	},

	watch: {


	},
  methods: {
	canEditNotificationSchedule() {
		if (this.$store.getters.userHasRole('system_admin')) {
			return true;
		}
		return false;
	},
	setNotificationTime() {
		if (this.form) {
			let timeVal = parseInt(this.timeLength);
			if (this.timeUnit == "minutes") {
				//
			} else if (this.timeUnit == "hours") {
				timeVal = timeVal * 60;
			} else if (this.timeUnit == "days") {
				timeVal = timeVal * 60 * 24;
			} else if (this.timeUnit == "weeks") {
				timeVal = timeVal * 60 * 24 * 7;
			}
			if (this.timeframe == "before") {
				timeVal = timeVal * (-1);
			}
			this.form.fromMinute.value = timeVal;
			this.form.toMinute.value = timeVal + parseInt(this.retryMinutes);
		}
	},

	setTimeFields() {
		if (this.form) {
			if (this.form.fromMinute) {
				let timeVal = parseInt(this.form.fromMinute.value);
				if (timeVal < 0) {
					this.timeframe = "before";
				} else {
					this.timeframe = "after";
				}
				// see if
				if (timeVal % 10080 == 1) {
					// its weeks..
					this.timeUnit = "weeks";
					this.timeLength = timeVal / 10080;
				} else if (timeVal % 1440 == 1) {
					// its days..
					this.timeUnit = "days";
					this.timeLength = timeVal / 1440;
				} else if (timeVal % 60 == 1) {
					this.timeUnit = "hours";
					this.timeLength = timeVal / 60;
				} else {
					this.timeUnit = "minutes";
					this.timeLength = timeVal;
				}
			}
		}
	},


	getIsApprovedText(val) {
		if (val) {
			return NotificationSchedule.getIsApprovedText(val);
		}
		return null;
	},
	getIsActiveText(val) {
		if (val) {
			return NotificationSchedule.getIsActiveText(val);
		}
		return null;
	},
	getLevelClassName(level) {
		return "level-"+level;
	},
	getFlatTree(option) {
		if (option) {
		if (option.namePath) {
			return Format.pipesToFlatTree(option.namePath);
		} else {
			return option.name;
		}
		}
		return null;
	},
	setLcrRquired() {
		if (this.form.lcrUser.value == "user_in_org") {
			this.form.organizationId.required = true;
		} else {
			this.form.organizationId.required = false;
		}
	},
	setOrganization(val) {
		let x = 0;
		if (typeof val == "object") {
		for (x = 0; x < this.organizations.length; x++) {
				if (val) {
			if (val.id == 	this.organizations[x].id) {

				this.organizationInfo = this.organizations[x];
			}
		}
			}
		} else {
		for (x = 0; x < this.organizations.length; x++) {
			if (val == 	this.organizations[x].id) {
				this.organizationInfo = this.organizations[x];
			}
		}
		}
	},


	GetOrganizations() {
		this.$store.dispatch('organizationList/loadEditable', {keywords:null})
			.then(() => {
					this.organizations = [];
					let records = this.$store.getters['organizationList/getRecords'];
					if ( records ) {
						records.forEach( item => {
							if (item.isActive == 0) item.name += " (inactive)";
							this.organizations.push(item);
							if (item.id == this.form.organizationId.value) {
								this.form.organizationId.value = item;
							}
						})
					}
					this.setLcrRquired();
					this.loaded = true;
				})
			.catch( error => console.log('error', error) ); // eslint-disable-line
	},

	// required fields notifying modal
	modalRequiredFieldClose(){
		this.showRequiredFieldModal = false;
	},
	showErrors(errors){
		this.submissionStatus = 'submission-error';
		this.modalRequiredFieldList = [];
		for(let field in errors) {
			this.modalRequiredFieldList.push(errors[field]);
		}
		this.showRequiredFieldModal = true;
	},

		onSubmit(evt) {
			evt.preventDefault()
			if (!this.validateFields()) {
				return false;
			}

			let that = this;
			return new Promise(function(resolve,reject){
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				that.SaveNew(that.form);
			});

		},
		onReset(evt) {
			evt.preventDefault()
			this.show = false
			this.$nextTick(() => {
			this.show = true
			})
		},

		onCancel(evt) {
			this.$router.push("/admin/notification-schedule-list/");
		},
		SaveNew(t) {
			// Saves a new organization
			if (t instanceof NotificationSchedule) {
				let go = true;
				if (go) {
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/notification-schedule/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: t.getRawValue()
				}).then(() => {
					// Handle Success
					this.saveState = 'success';
					this.submissionStatus = 'submission-success';
					this.SaveNewSuccess();
					this.onSubmitPromiseDeferred.resolve();
				}).catch(error => {
					this.saveState = 'fail';
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.form.SetErrors(error.response.data);
						this.showErrors(error.response.data.fields);
					} else {
						// ErrorHandler.RedirectToLogin();
					}
					this.onSubmitPromiseDeferred.reject();
				}).finally(() => {
					this.isButtonDisabled = false;
				});
				}
			}
		},
		SaveExisting(t) {
			if (t instanceof NotificationSchedule) {
				if (t.lcrUser.value != "user_in_org") {
					t.organizationId.value = null;
				}
				Vue.prototype.$http({
					method: 'put',
					url: Format.getApiUrl("/notification-schedule/"+t.id),
					data: t.getRawValue()
				}).then(() => {
					this.saveState = 'success';
					this.submissionStatus = 'submission-success';
					this.SaveExistingSuccess();
					this.onSubmitPromiseDeferred.resolve();
				}).catch(error => {
					this.saveState = 'fail';
					if (error) {
						if (error.response) {
							if (!ErrorHandler.HasLoginErrorCode(error)) {
								// this.form.SetErrors(error.response.data);
								this.showErrors(error.response.data.fields);
							} else {
								ErrorHandler.RedirectToLogin();
							}
						}
					}
					this.onSubmitPromiseDeferred.reject();
				}).finally(() => {
				});
			}
		},

		SaveExistingSuccess() {
			this.form.saveChanges();
			this.$router.push("/admin/notification-schedule-list/");
		},

		SaveNewSuccess() {
			this.form.saveChanges();
			this.$router.push("/admin/notification-schedule-list/");
		},

		validateFields() {
			let valid = this.form.validate();

			if (this.form.organizationId.required) {
				this.form.organizationId.validate();
				if (!this.form.organizationId.valid) {
				valid = false;
			}
			}

			if (valid ) {
				return true;
			}
			return false;
		},


			LoadData(id = this.id) {
				this.loaded = false;
				// Remove any messages being displayed.
				this.submissionStatus = null;
				if (id && Format.TryParseInt(id) > 0) {
					this.GetData(id);
				} else {
					this.form = new NotificationSchedule();
					this.form.isActive.value = 1;
					this.loaded = true;
					this.form.saveChanges();
				}
			},


			GetData(id) {

				if (Format.TryParseInt(id)) {
					this.loaded = false;
					Vue.prototype.$http.get(this.$store.state.apiUrl + "/notification-schedule/" + id + "?r=" + Math.round(Math.random() * Math.pow(10, 6)))
					.then(response => {
						this.form = new NotificationSchedule(response.data);
						this.$nextTick(() => {
							this.loaded = true;
							this.retryMinutes = Math.abs(Math.abs(this.form.fromMinute.value) - Math.abs(this.form.toMinute.value));
							this.setTimeFields();
							this.setNotificationTime();
							this.$nextTick(() => {
								this.GetOrganizations();
							})
						})


					}).catch(error => {
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							if (error.response && error.response.data) {
								this.loaded = false;
								this.transactionStatus = 'load-error';
								this.errorDetails = error.response.data;
							}
						} else {
							ErrorHandler.RedirectToLogin();
						}
					});
				}

			},

			toggleEnabled: function(index, uindex) {
				if (this.form.isActive.value == 1) {
					this.form.isActive.value = 0;
				} else {
					this.form.isActive.value = 1;
				}
			},

			modalOnCancel() {
				this.showUnsavedChangesModal = false;
			},

	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			Vue.prototype.$bus.$emit("map:clear", 1);
			Vue.prototype.$bus.$emit("map:toggle", 0);
	});
	},
	beforeRouteLeave(to, from, next) {
		if (this.loaded && this.form.hasChanges()) {
			if (this.overrideUnsavedChanges) {
				next(true);
			} else {
				this.showUnsavedChangesModal = true;
				this.modalOnSave = (function() {
					this.onSubmit().then(() => {
						next(true);
					}).catch(() => {
						next(false);
					});
				}).bind(this);

				this.modalOnLeave = (function() {
					this.showUnsavedChangesModal = false;
					next(true);
				}).bind(this);

				next(false);
			}
		}
		else {
			next(true);
		}
	},


}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>